// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type GetCompanyEmailDomainQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type GetCompanyEmailDomainQuery = { __typename?: 'Query' } & {
  companyEmailDomain: Types.Maybe<
    { __typename?: 'CompanyEmailDomain' } & Pick<Types.CompanyEmailDomain, 'id' | 'disableExternalAccount'>
  >;
};

export const GetCompanyEmailDomainDocument = /*#__PURE__*/ gql`
    query getCompanyEmailDomain($id: ID!) {
  companyEmailDomain(id: $id) {
    id
    disableExternalAccount
  }
}
    `;

/**
 * __useGetCompanyEmailDomainQuery__
 *
 * To run a query within a React component, call `useGetCompanyEmailDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyEmailDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyEmailDomainQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyEmailDomainQuery(
  baseOptions: Apollo.QueryHookOptions<GetCompanyEmailDomainQuery, GetCompanyEmailDomainQueryVariables> &
    ({ variables: GetCompanyEmailDomainQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCompanyEmailDomainQuery, GetCompanyEmailDomainQueryVariables>(
    GetCompanyEmailDomainDocument,
    options,
  );
}
export function useGetCompanyEmailDomainLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyEmailDomainQuery, GetCompanyEmailDomainQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCompanyEmailDomainQuery, GetCompanyEmailDomainQueryVariables>(
    GetCompanyEmailDomainDocument,
    options,
  );
}
// @ts-expect-error
export function useGetCompanyEmailDomainSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyEmailDomainQuery, GetCompanyEmailDomainQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetCompanyEmailDomainQuery, GetCompanyEmailDomainQueryVariables>;
export function useGetCompanyEmailDomainSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCompanyEmailDomainQuery, GetCompanyEmailDomainQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetCompanyEmailDomainQuery | undefined, GetCompanyEmailDomainQueryVariables>;
export function useGetCompanyEmailDomainSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCompanyEmailDomainQuery, GetCompanyEmailDomainQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCompanyEmailDomainQuery, GetCompanyEmailDomainQueryVariables>(
    GetCompanyEmailDomainDocument,
    options,
  );
}
export type GetCompanyEmailDomainQueryHookResult = ReturnType<typeof useGetCompanyEmailDomainQuery>;
export type GetCompanyEmailDomainLazyQueryHookResult = ReturnType<typeof useGetCompanyEmailDomainLazyQuery>;
export type GetCompanyEmailDomainSuspenseQueryHookResult = ReturnType<typeof useGetCompanyEmailDomainSuspenseQuery>;
